export default __webpack_public_path__ + "static/media/wallet02.bfe983f8.png";